module.exports = __webpack_public_path__ + "static/media/BankSetup.08bb30e8.png";